var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAttack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2247_13878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3686 6.25L43.7498 6.25625L43.754 13.5958L32.3644 24.9833L38.2561 30.8771L41.204 27.9312L44.1498 30.8771L38.9956 36.0333L44.8873 41.9271L41.9415 44.8729L36.0477 38.9792L30.8915 44.1354L27.9456 41.1896L30.8915 38.2417L24.9977 32.35L19.1061 38.2417L22.054 41.1896L19.1081 44.1354L13.9519 38.9792L8.05814 44.8729L5.1123 41.9271L11.0061 36.0312L5.8498 30.8771L8.79564 27.9312L11.7415 30.875L17.6311 24.9833L6.25605 13.6083L6.2498 6.25L13.6373 6.25625L24.9977 17.6187L36.3686 6.25ZM20.5769 27.9292L14.6873 33.8208L16.1623 35.2937L22.0519 29.4021L20.579 27.9292H20.5769ZM39.5852 10.4187H38.0915L27.9456 20.5625L29.4165 22.0354L39.5852 11.8708V10.4187ZM10.4186 10.4187V11.8771L33.8373 35.2958L35.3102 33.8229L11.9081 10.4208L10.4186 10.4187Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2247_13878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttack);
export default __webpack_public_path__ + "static/media/icon-attack.20448f3e0ec16ac5566950952711eec6.svg";
export { ForwardRef as ReactComponent };